var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#C7CDDD",
  d: "M4.5 6.5h23v6h-23z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  d: "M11 25v-3h10v3zM8 19v-3h16v3z"
})));
export { SvgIcAi as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNC41IiB5PSI2LjUiIHdpZHRoPSIyMyIgaGVpZ2h0PSI2IiBzdHJva2U9IiNDN0NEREQiLz4KPHJlY3QgeD0iMTEiIHk9IjI1IiB3aWR0aD0iMyIgaGVpZ2h0PSIxMCIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDExIDI1KSIgZmlsbD0iI0M3Q0RERCIvPgo8cmVjdCB4PSI4IiB5PSIxOSIgd2lkdGg9IjMiIGhlaWdodD0iMTYiIHRyYW5zZm9ybT0icm90YXRlKC05MCA4IDE5KSIgZmlsbD0iI0M3Q0RERCIvPgo8L3N2Zz4K";